













import { SearchResultsDocumentModel, BackgroundExportRequestDataModel, BackgroundDeleteResultModel, QueueBackgroundTaskResultModel } from '@/services/GeneratedApi';
import { BvModalEvent } from 'bootstrap-vue';
import { ColourVariantType } from '@/types';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import ApiConfiguration from '@/classes/ApiConfiguration';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { ModalHelpers } from '@/mixins';
import { AppSettingsHelper } from '@/mixins/appSettingsHelper';
export default {
  mixins: [AppSettingsHelper, ModalHelpers],
  data() {
    return {
      showModal: false,
      cancelled: false,
      deleteRequest: {} as BackgroundExportRequestDataModel,
      deleteStatus: ''
    };
  },
  props: {
    selectedDocuments: {
      type: Array as () => SearchResultsDocumentModel[]
    }
  },
  methods: {
    async deleteDocuments(this: any) {
      this.deleteRequest = {
        documents: this.selectedDocuments.map(({ cabinetId, documentId, documentTypeId }: SearchResultsDocumentModel) => ({
          documentId,
          cabinetId,
          documentTypeId
        }))
      };

      const totalPageCount = this.selectedDocuments.reduce((p: number, c: SearchResultsDocumentModel) => p + c.pages!, 0);
      const backgroundDeletePageThreshold = this.appSettings.backgroundDeleteOptions.backgroundDeletePageThreshold;

      if (totalPageCount > backgroundDeletePageThreshold) {
        await this.queueDelete(totalPageCount);
        return;
      }

      this.deleteStatus = this.deleteRequest.documents.length === 1 ? 'Deleting 1 document' : `Deleting ${this.deleteRequest.documents.length} documents`;
      this.showModal = true;
      let result;
      try {
        result = (await ApiConfiguration.api().document.documentBackgrounddeleteCreate(this.deleteRequest)) as BackgroundDeleteResultModel;
        if (result.allDocumentsDeleted) {
          SnotifyConfiguration.showSuccess(result.endUserMessage ?? (this.deleteRequest.documents.length === 1 ? 'Document deleted successfully.' : 'All documents deleted successfully.'));
        } else {
          SnotifyConfiguration.showInformation(result!.endUserMessage ?? 'Warning: Some of the documents could not be deleted at this time.');
        }
      } catch (error) {
        this.$log(error);
      } finally {
        this.showModal = false;
        this.$emit('link-action:completed', result);
        this.$emit('link-action:refresh');
      }
    },
    async queueDelete(this: any, totalPageCount: number) {
      const confirmation = await ModalHelpers.methods.showConfirmationModalAsync(
        this.$bvModal,
        `Deleting ${totalPageCount} document pages will take a while.
        The process will continue in the background and you'll receive a notification when it's complete. Do you want to continue?`,
        {
          okVariant: ColourVariantType.Primary,
          cancelVariant: ColourVariantType.Danger,
          okTitle: 'Continue'
        }
      );

      if (!confirmation) {
        this.$emit('link-action:completed');
        return;
      }

      try {
        const result: QueueBackgroundTaskResultModel = await ApiConfiguration.api().document.documentQueuebackgrounddeleteCreate(this.deleteRequest);
        SnotifyConfiguration.showSuccess(result.endUserMessage ?? 'Delete queued successfully.');
      } catch (error) {
        this.$log(error);
      }

      this.$emit('link-action:completed');
    },
    onCancel(this: any, bvModalEvent: BvModalEvent) {
      bvModalEvent.preventDefault();
      this.cancelled = true;
      this.$emit('link-action:completed');
    }
  },
  components: {
    LoadingSpinner
  },

  async mounted(this: any) {
    await this.deleteDocuments();
  }
};
